import * as dat from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import portalVertexShader from './shaders/portal/vertex.glsl'
import portalFragmentShader from './shaders/portal/fragment.glsl'
import portalVertexShader1 from './shaders/portal/vertex1.glsl'
import portalFragmentShader1 from './shaders/portal/fragment1.glsl'
import { gsap } from 'gsap'


/**
 * Base
 */

const screenWidth = window.innerWidth
const end_overlay = document.querySelector('.hover')
const aspect_enable = document.querySelector('.back_mess')
const cancel = document.querySelector('.cancel')
const cancel2 = document.querySelector('.cancel2')
const cancel3 = document.querySelector('.cancel3')
const type = document.querySelector('.type')
const end = document.querySelector('.end')

const loadingBarElement = document.querySelector('.part1')
const loadingBarElement1 = document.querySelector('.loading-bar')

const Enter = document.querySelector('.text-field__input')

const button1 = document.querySelector('.esc')
const button2 = document.querySelector('.back')
const button3 = document.querySelector('.caps')

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

//Clock
const clock = new THREE.Clock()

/**
 * Music
 */
const audioContext = new AudioContext();
const audioUrl = 'ES_Nocturnal Soul - Sonum.mp3';
const audioRequest = new XMLHttpRequest();
audioRequest.open('GET', audioUrl, true);
audioRequest.responseType = 'arraybuffer';
const playButton = document.querySelector('.webgl')

audioRequest.onload = () => {
  audioContext.decodeAudioData(audioRequest.response, (buffer) => {
    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    source.connect(audioContext.destination);
    source.loop = true;
    playButton.addEventListener('click', () => {
        source.start(0);
    });
  });
};

audioRequest.send();

/**
 * Loaders
 */


//Loading Manager
const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
        window.setTimeout(() =>
        {
            gsap.to(overlayMaterial_load2.uniforms.uAlpha, { duration: 3, value: 0, })

            loadingBarElement1.classList.add('ended')
            setTimeout(() => {
                loadingBarElement1.style.display = 'none'
            }, 2000);
        }, 500)
    },

    // Progress
    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        const progressRatio = itemsLoaded / itemsTotal * 80.950
        loadingBarElement.style.width = `${progressRatio}vw`
    }
)
// Texture loader
const textureLoader = new THREE.TextureLoader(loadingManager)
// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
/**
 * Camera
 */
const cameraDirection = new THREE.Vector3(-11.77, 3.09, -6.1);
let camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 35
camera.position.y = 22
camera.position.z = -6
scene.add(camera)

/**
 * Textures
 */
const bakedTexture_plane = textureLoader.load('plane_last.jpg')
bakedTexture_plane.flipY = false
bakedTexture_plane.encoding = THREE.sRGBEncoding
const bakedTexture_tape = textureLoader.load('tape.jpg')
bakedTexture_tape.flipY = false
bakedTexture_tape.encoding = THREE.sRGBEncoding
const bakedTexture_chair1 = textureLoader.load('chair1.jpg')
bakedTexture_chair1.flipY = false
bakedTexture_chair1.encoding = THREE.sRGBEncoding
const bakedTexture_chair2 = textureLoader.load('chair2.jpg')
bakedTexture_chair2.flipY = false
bakedTexture_chair2.encoding = THREE.sRGBEncoding
const bakedTexture_table = textureLoader.load('table1.jpg')
bakedTexture_table.flipY = false
bakedTexture_table.encoding = THREE.sRGBEncoding
const bakedTexture_car = textureLoader.load('car_proj.jpg')
bakedTexture_car.flipY = false
bakedTexture_car.encoding = THREE.sRGBEncoding
const bakedTexture_slot = textureLoader.load('slot_last.jpg')
bakedTexture_slot.flipY = false
bakedTexture_slot.encoding = THREE.sRGBEncoding
const bakedTexture_bar1 = textureLoader.load('bar1.jpg')
bakedTexture_bar1.flipY = false
bakedTexture_bar1.encoding = THREE.sRGBEncoding
const bakedTexture_chairbar = textureLoader.load('chairbar.jpg')
bakedTexture_chairbar.flipY = false
bakedTexture_chairbar.encoding = THREE.sRGBEncoding
const bakedTexture_glass = textureLoader.load('glass.jpg')
bakedTexture_glass.flipY = false
bakedTexture_glass.encoding = THREE.sRGBEncoding
const bakedTexture_bar_main = textureLoader.load('bar_main.001.jpg')
bakedTexture_bar_main.flipY = false
bakedTexture_bar_main.encoding = THREE.sRGBEncoding
const bakedTexture_light = textureLoader.load('light.jpg')
bakedTexture_light.flipY = false
bakedTexture_light.encoding = THREE.sRGBEncoding
const bakedTexture_bar_rather = textureLoader.load('bar_rather.jpg')
bakedTexture_bar_rather.flipY = false
bakedTexture_bar_rather.encoding = THREE.sRGBEncoding
const bakedTexture_bottles = textureLoader.load('bottles.jpg')
bakedTexture_bottles.flipY = false
bakedTexture_bottles.encoding = THREE.sRGBEncoding
const bakedTexture_name = textureLoader.load('name.jpg')
bakedTexture_name.flipY = false
bakedTexture_name.encoding = THREE.sRGBEncoding
const bakedTexture_doors = textureLoader.load('doors.jpg')
bakedTexture_doors.flipY = false
bakedTexture_doors.encoding = THREE.sRGBEncoding
const bakedTexture_razdev_main = textureLoader.load('razdev.jpg')
bakedTexture_razdev_main.flipY = false
bakedTexture_razdev_main.encoding = THREE.sRGBEncoding
const bakedTexture_window = textureLoader.load('window.jpg')
bakedTexture_window.flipY = false
bakedTexture_window.encoding = THREE.sRGBEncoding
const bakedTexture_line = textureLoader.load('line.jpg')
bakedTexture_line.flipY = false
bakedTexture_line.encoding = THREE.sRGBEncoding
const bakedTexture_B = textureLoader.load('B.jpg')
bakedTexture_B.flipY = false
bakedTexture_B.encoding = THREE.sRGBEncoding
const bakedTexture_pendant = textureLoader.load('pendant.jpg')
bakedTexture_pendant.flipY = false
bakedTexture_pendant.encoding = THREE.sRGBEncoding
const bakedTexture_head = textureLoader.load('head2.jpg')
bakedTexture_head.flipY = false
bakedTexture_head.encoding = THREE.sRGBEncoding
const bakedTexture_wom1 = textureLoader.load('wom1.jpg')
bakedTexture_wom1.flipY = false
bakedTexture_wom1.encoding = THREE.sRGBEncoding
const bakedTexture_iphone = textureLoader.load('iphone.jpg')
bakedTexture_iphone.flipY = false
bakedTexture_iphone.encoding = THREE.sRGBEncoding
/**
 * Materials
 */
// Baked material
const bakedMaterial_plane = new THREE.MeshBasicMaterial({ map: bakedTexture_plane })
const bakedMaterial_tape = new THREE.MeshBasicMaterial({ map: bakedTexture_tape })
const bakedMaterial_chair1 = new THREE.MeshBasicMaterial({ map: bakedTexture_chair1 })
const bakedMaterial_chair2 = new THREE.MeshBasicMaterial({ map: bakedTexture_chair2 })
const bakedMaterial_table = new THREE.MeshBasicMaterial({ map: bakedTexture_table })
const bakedMaterial_car = new THREE.MeshBasicMaterial({ map: bakedTexture_car })
const bakedMaterial_slot = new THREE.MeshBasicMaterial({ map: bakedTexture_slot })
const bakedMaterial_bar1 = new THREE.MeshBasicMaterial({ map: bakedTexture_bar1 })
const bakedMaterial_chairbar = new THREE.MeshBasicMaterial({ map: bakedTexture_chairbar })
const bakedMaterial_glass = new THREE.MeshBasicMaterial({ map: bakedTexture_glass })
const bakedMaterial_bar_main = new THREE.MeshBasicMaterial({ map: bakedTexture_bar_main })
const bakedMaterial_light = new THREE.MeshBasicMaterial({ map: bakedTexture_light })
const bakedMaterial_bar_rather = new THREE.MeshBasicMaterial({ map: bakedTexture_bar_rather })
const bakedMaterial_bottles = new THREE.MeshBasicMaterial({ map: bakedTexture_bottles })
const bakedMaterial_name = new THREE.MeshBasicMaterial({ map: bakedTexture_name })
const bakedMaterial_doors = new THREE.MeshBasicMaterial({ map: bakedTexture_doors })
const bakedMaterial_razdev_main = new THREE.MeshBasicMaterial({ map: bakedTexture_razdev_main })
const bakedMaterial_window = new THREE.MeshBasicMaterial({ map: bakedTexture_window })
const bakedMaterial_line = new THREE.MeshBasicMaterial({ map: bakedTexture_line })
const bakedMaterial_B = new THREE.MeshBasicMaterial({ map: bakedTexture_B })
const bakedMaterial_pendant = new THREE.MeshBasicMaterial({ map: bakedTexture_pendant })
const bakedMaterial_head = new THREE.MeshBasicMaterial({ map: bakedTexture_head })
const bakedMaterial_wom1 = new THREE.MeshBasicMaterial({ map: bakedTexture_wom1 })
const bakedMaterial_iphone = new THREE.MeshBasicMaterial({ map: bakedTexture_iphone })
const bakedMaterial_plane2 = new THREE.MeshBasicMaterial({ color: 0xff0000 })

// Shader materials
const overlayMaterial_load2 = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 },
    },
    vertexShader: `
        void main()
        {  
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
    uniform float uAlpha;

    void main()
    {
        gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
    }
    `
})

const portalLightMaterial = new THREE.ShaderMaterial({
    uniforms:
    {
        uTime: { value: 0 },
        uColorStart: { value: new THREE.Color('#636363') },
        uColorEnd: { value: new THREE.Color('#ffffff') }
    },
    vertexShader: portalVertexShader,
    fragmentShader: portalFragmentShader
})


const portalLightMaterial3 = new THREE.ShaderMaterial({
    uniforms:
    {
        uTime: { value: 0 },
        uColorStart: { value: new THREE.Color('#161616') },
        uColorEnd: { value: new THREE.Color('#757575') }
    },
    vertexShader: portalVertexShader,
    fragmentShader: portalFragmentShader
})

const portalLightMaterial1 = new THREE.ShaderMaterial({
    uniforms:
    {
        uTime: { value: 0 },
        uColorStart: { value: new THREE.Color('#421B06') },
        uColorEnd: { value: new THREE.Color('#C99570') }
    },
    vertexShader: portalVertexShader1,
    fragmentShader: portalFragmentShader1
})
/**
 * Model
 */

// Overlay1
const overlayGeometry1 = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlay_load1 = new THREE.Mesh(overlayGeometry1, overlayMaterial_load2)
scene.add(overlay_load1)

//Scene
gltfLoader.load(
    'art_gen.glb',
    (gltf) =>
    {
        scene.add(gltf.scene)

        const MainPlane = gltf.scene.children.find((child) => child.name === 'Plane')
        MainPlane.material = bakedMaterial_plane
        const Chair1 = gltf.scene.children.find((child) => child.name === 'Cylinder012')
        Chair1.material = bakedMaterial_chair1
        const Chair2 = gltf.scene.children.find((child) => child.name === 'Cube018')
        Chair2.material = bakedMaterial_chair2
        const ChairBar = gltf.scene.children.find((child) => child.name === 'Cube002')
        ChairBar.material = bakedMaterial_chairbar

    }
)


//Table
let table = null
gltfLoader.load(
    'table.glb',
    (gltf) =>
    {
        table = gltf.scene
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial_table
        })
        scene.add(table)
    }
);

//Raycaster
const raycaster = new THREE.Raycaster()
let currentIntersect_m = null
let currentIntersect = null
let currentIntersect2 = null
let currentIntersect3 = null
let currentIntersect4 = null
let currentIntersect5 = null
let currentIntersect6 = null
let currentIntersect7 = null
let currentIntersect8 = null
let currentIntersect9 = null
let currentIntersect10 = null
const rayOrigin = new THREE.Vector3(0.75, 2.94, -1.41)
const rayDirection = new THREE.Vector3(-50.39, 2.72, -3.14)
rayDirection.normalize()

//Overlay2
let overlay = new THREE.Mesh(
    new THREE.PlaneGeometry(50, 50),
    new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true })
);
scene.add( overlay );
let euler1 = new THREE.Euler(-Math.PI / 4, Math.PI / 3, 0, 'ZYX')
overlay.setRotationFromEuler(euler1);
overlay.position.x = -23.2

//Pappers
let pappers = null
gltfLoader.load(
    'pappers.glb',
    (gltf) =>
    {
        pappers = gltf.scene
        scene.add(pappers)
    }
);

if (screenWidth > 1024) {
    let pappers_mess = null
    gltfLoader.load(
        'pappers_mess.glb',
        (gltf) =>
        {
            pappers_mess = gltf.scene
            scene.add(pappers_mess)
        }
    );
}

else {
    let pappers_mess2 = null
    gltfLoader.load(
        'pappers_mess2.glb',
        (gltf) =>
        {
            pappers_mess2 = gltf.scene
            scene.add(pappers_mess2)
        }
    );
}

//Slot machines
let slot = null;
gltfLoader.load(
    'slot.glb',
    (gltf) =>
    {
        slot = gltf.scene
        slot.traverse((child) =>
        {
            child.material = bakedMaterial_slot
        })
        scene.add(slot)
    }
)

gltfLoader.load(
    'images.glb',
    (gltf) =>
    {
        scene.add(gltf.scene)
    }
)

//Tape
let tape = null;
gltfLoader.load(
    'tape.glb',
    (gltf) =>
    {
        tape = gltf.scene
        tape.traverse((child) =>
        {
            child.material = bakedMaterial_tape
        })
        scene.add(tape)
    }
)

//Card
gltfLoader.load(
    'card.glb',
    (gltf) =>
    {
        scene.add(gltf.scene)
    }
)

//Bar
let bar = null;
gltfLoader.load(
    'bar.glb',
    (gltf) =>
    {
        bar = gltf.scene
        bar.traverse((child) =>
        {
            child.material = bakedMaterial_plane2
        })
        scene.add(bar)

        const Bar1 = gltf.scene.children.find((child) => child.name === 'Cube033')
        Bar1.material = bakedMaterial_bar1
        const Bar2 = gltf.scene.children.find((child) => child.name === 'Plane019')
        Bar2.material = bakedMaterial_bar1
        const Glass = gltf.scene.children.find((child) => child.name === 'Wine')
        Glass.material = bakedMaterial_glass
        const Bar_main = gltf.scene.children.find((child) => child.name === 'Cube006')
        Bar_main.material = bakedMaterial_bar_main
        const Light = gltf.scene.children.find((child) => child.name === 'Plane182')
        Light.material = bakedMaterial_light
        const Bar_rather = gltf.scene.children.find((child) => child.name === 'Cube008')
        Bar_rather.material = bakedMaterial_bar_rather
        const Bottles = gltf.scene.children.find((child) => child.name === 'Hennessy007')
        Bottles.material = bakedMaterial_bottles
        const Name = gltf.scene.children.find((child) => child.name === 'Text001')
        Name.material = bakedMaterial_name
    }
)

//Car
let car
gltfLoader.load(
    'car_proj.glb',
    (gltf) =>
    {
        car = gltf.scene
        car.traverse((child) =>
        {
            child.material = bakedMaterial_car
        })
        scene.add(car)
    }
)

let window1
gltfLoader.load(
    'window.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial_window
        })
        window1 = gltf.scene
        scene.add(window1)
    }
)

gltfLoader.load(
    'line.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial_line
        })
        scene.add(gltf.scene)
    }
)

//Doors
let door = null;
gltfLoader.load(
    'doors.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial_doors
        })
        scene.add(gltf.scene)

        door = scene.getObjectByName( "Cylinder002" );
    }
)

// Lights
const ambientLight = new THREE.AmbientLight()
ambientLight.color = new THREE.Color(0xffffff)
ambientLight.intensity = 0.7
scene.add(ambientLight)

//Locker room
let razdev_main
gltfLoader.load(
    'razdev_main.glb',
    (gltf) =>
    {
        razdev_main = gltf.scene
        razdev_main.traverse((child) =>
        {
            child.material = bakedMaterial_razdev_main;
            child.position.x -= 20
            child.position.z -= 19
            child.position.y += 0.85
        })
        scene.add(razdev_main)
        razdev_main.rotateY(Math.PI / 2)

    }
);
let razdev
gltfLoader.load(
    'razdev.glb',
    (gltf) =>
    {
        razdev = gltf.scene
        scene.add(razdev)
        razdev.rotateY(Math.PI / 2)
        razdev.position.x -= 39
        razdev.position.y += 1.7
        razdev.position.z += 1
    }
);
let razdev1
let cloth1
let cloth3
gltfLoader.load(
    'razdev1.glb',
    (gltf) =>
    {
        razdev1 = gltf.scene
        razdev1.traverse((child) =>
        {
            child.position.x -= 20
            child.position.z -= 19
            child.position.y += 0.85
        })
        scene.add(razdev1)
        cloth1 = gltf.scene.children.find((child) => child.name === 'mm_frame_(3)')
        cloth3 = gltf.scene.children.find((child) => child.name === 'mm_frame_(11)')
        razdev1.rotateY(Math.PI / 2)
    }
);
let cloth4
let razdev2
gltfLoader.load(
    'razdev2.glb',
    (gltf) =>
    {
        razdev2 = gltf.scene
        razdev2.traverse((child) =>
        {
            child.position.x -= 20
            child.position.z -= 19
            child.position.y += 0.85
        })
        scene.add(razdev2)
        cloth4 = gltf.scene.children.find((child) => child.name === 'mm_frame_(15)')
        razdev2.rotateY(Math.PI / 2)
    }
);
let razdev3
let cloth2;
gltfLoader.load(
    'razdev3.glb',
    (gltf) =>
    {
        razdev3 = gltf.scene
        razdev3.traverse((child) =>
        {
            child.position.x -= 20
            child.position.z -= 19
            child.position.y += 0.85
        })
        scene.add(razdev3)
        razdev3.rotateY(Math.PI / 2)
        cloth2 = gltf.scene.children.find((child) => child.name === 'mm_frame_(17)')
    }
);

//Woman1
let Woman2
gltfLoader.load(
    'woman2.glb',
    (gltf) =>
    {
        Woman2 = gltf.scene
        scene.add(Woman2)
    }
);

//Woman2
let Woman3
gltfLoader.load(
    'woman3.glb',
    (gltf) =>
    {
        Woman3 = gltf.scene
        scene.add(Woman3)
    }
);

//Woman3
let Woman4
gltfLoader.load(
    'woman4.glb',
    (gltf) =>
    {
        Woman4 = gltf.scene
        scene.add(Woman4)
    }
);


//Man1
let Man1
gltfLoader.load(
    'man1.glb',
    (gltf) =>
    {
        Man1 = gltf.scene
        scene.add(Man1)
    }
);

//Man2
let Man2
gltfLoader.load(
    'man2.glb',
    (gltf) =>
    {
        Man2 = gltf.scene
        scene.add(Man2)
    }
);

//Man3
let Man3
gltfLoader.load(
    'man3.glb',
    (gltf) =>
    {
        Man3 = gltf.scene
        scene.add(Man3)
    }
);

//Man4
let Man4
gltfLoader.load(
    'man4.glb',
    (gltf) =>
    {
        Man4 = gltf.scene
        scene.add(Man4)
    }
);

//Man5
let Man5
gltfLoader.load(
    'man5.glb',
    (gltf) =>
    {
        Man5 = gltf.scene
        scene.add(Man5)
    }
);

//Iphone
let Iphone
gltfLoader.load(
    'iphone.glb',
    (gltf) =>
    {
        Iphone = gltf.scene
        Iphone.traverse((child) =>
        {
            child.material = bakedMaterial_iphone
        })
        scene.add(Iphone)
    }
);

//Cap
let cap
gltfLoader.load(
    'cap.glb',
    (gltf) =>
    {
        cap = gltf.scene
        scene.add(cap)
        cap.rotateY(Math.PI / 2)
        cap.children[0].position.x = -3.32
        cap.children[0].position.y = 5.48
        cap.children[0].position.z = -36.55
    }
);

//Watch
let watch
gltfLoader.load(
    'watch.glb',
    (gltf) =>
    {
        watch = gltf.scene
        scene.add(watch)
        watch.rotateY(Math.PI / 2)
        watch.children[0].position.x = -3.32
        watch.children[0].position.y = 5.48
        watch.children[0].position.z = -36.55
    }
);

//Pendant
let pendant
gltfLoader.load(
    'pendant.glb',
    (gltf) =>
    {
        pendant = gltf.scene
        pendant.traverse((child) =>
        {
            child.material = bakedMaterial_pendant
        })
        scene.add(pendant)
        pendant.rotateY(Math.PI / 2)
        pendant.children[0].position.x = -1.33
        pendant.children[0].position.y = 5.12
        pendant.children[0].position.z = -36.55
    }
);

//Head
let head
gltfLoader.load(
    'head.glb',
    (gltf) =>
    {
        head = gltf.scene
        head.traverse((child) =>
        {
            child.material = bakedMaterial_head
        })
        scene.add(head)
        head.rotateY(Math.PI / 2)
        head.children[0].position.x = -1.33
        head.children[0].position.y = 5.12
        head.children[0].position.z = -36.55
    }
);

//Text B
let textb;
gltfLoader.load(
    'B.glb',
    (gltf) =>
    {
        textb = gltf.scene
        scene.add(textb)
        const MainPlane = gltf.scene.children.find((child) => child.name === 'Text004')
        MainPlane.material = bakedMaterial_B
    }
)

//Text1
let text1;
gltfLoader.load(
    'text1.glb',
    (gltf) =>
    {
        text1 = gltf.scene
        scene.add(text1)
        const Text = gltf.scene.children.find((child) => child.name === 'Text')
        Text.material = portalLightMaterial
        text1.children[0].position.x = 28.76
        text1.children[0].position.y = 14.95
        text1.children[0].position.z = 2.2
    }
)

//Text2
let text2;
gltfLoader.load(
    'text2.glb',
    (gltf) =>
    {
        text2 = gltf.scene
        scene.add(text2)
        const Text = gltf.scene.children.find((child) => child.name === 'Text042')
        Text.material = portalLightMaterial
        text2.visible = false; 
    }
)

//Text3
let text3;
gltfLoader.load(
    'text3.glb',
    (gltf) =>
    {
        text3 = gltf.scene
        scene.add(text3)
        const Text = gltf.scene.children.find((child) => child.name === 'Text043')
        Text.material = portalLightMaterial
        text3.visible = false;   
    }
)

//Text4
let text4;
gltfLoader.load(
    'text4.glb',
    (gltf) =>
    {
        text4 = gltf.scene
        scene.add(text4)
        const Text = gltf.scene.children.find((child) => child.name === 'Text003')
        Text.material = portalLightMaterial1
        text4.children[0].position.x = 6.04
        text4.visible = false;  
    }
)

//Text5
let text5;
gltfLoader.load(
    'text5.glb',
    (gltf) =>
    {
        text5 = gltf.scene
        scene.add(text5)
        const Text = gltf.scene.children.find((child) => child.name === 'Text')
        Text.material = portalLightMaterial3
        text5.visible = false;
        text5.children[0].position.x = -37.94
        text5.children[0].position.y = 4.3
        text5.children[0].position.z = -7.14
        text5.children[0].rotateZ(-Math.PI / 2); 
    }
)

//Text6
let text6;
gltfLoader.load(
    'text6.glb',
    (gltf) =>
    {
        text6 = gltf.scene
        scene.add(text6)
        const Text = gltf.scene.children.find((child) => child.name === 'Text001')
        Text.material = portalLightMaterial
        if (aspectRatio == 1.3333333333333333) {
            text6.children[0].position.x = -47.33
            text6.children[0].position.y = 5.03
            text6.children[0].position.z = 7.4
        }
        else {
            text6.children[0].position.x = -47.33
            text6.children[0].position.y = 3.13
            text6.children[0].position.z = 9.18
        }
        text6.children[0].rotateZ(-Math.PI / 2);
        text6.visible = false; 
    }
)

//Scroll
let scroll;
gltfLoader.load(
    'scroll.glb',
    (gltf) =>
    {
        scroll = gltf.scene
        scene.add(scroll)
        scroll.traverse((child) =>
        {
            child.material = portalLightMaterial
        })
        scroll.position.x = -0.2
        scroll.position.y = 0.87
        scroll.position.z = 1.91  
    }
)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

renderer.setSize(sizes.width, sizes.height)
const aspectRatio = camera.aspect;
if (aspectRatio < 1) {
    aspect_enable.style.display = 'block'
}


renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


/**
 * Scroll control
 */

const distanceThreshold = 27.21115620284087;
function updatepos() {
    let distance = camera.position.distanceTo(car.children[0].position);
    if (distance > distanceThreshold) {
        controls.enableRotate = false;
    } 
}

//Orientatin
let flag1 = false;
let currentPosition1 = new THREE.Vector3();
document.addEventListener('mousewheel', function (event) {
  if (event.deltaY < 0) {
    const distance = camera.position.distanceTo(table.position);
    if (distance < 27.7 && !flag1) {
        camera.updateProjectionMatrix();
        currentPosition1.copy(camera.position)
        flag1 = true
    };
  }
}, { passive: false });

//Scroll back
let currentPosition2 = new THREE.Vector3();
currentPosition2.copy(camera.position)

document.addEventListener('mousewheel', function (event) {
  if (event.deltaY > 0) {
    const distance = camera.position.distanceTo(car.position);
    if (distance > 35) {
        camera.position.set(currentPosition2.x, currentPosition2.y, currentPosition2.z)  
    }
  }
}, { passive: false });

//Scroll forward
let speed = 1.5;

let flag2 = false;
let flag3 = false;
let currentPosition3 = new THREE.Vector3();
let currentPosition4 = new THREE.Vector3();
document.addEventListener('mousewheel', function (event) {
  let direction = event.deltaY > 0 ? -1 : 1;
  window1.position.y -= direction * speed;
  if (window1.position.y == 0 && !flag3) {
    currentPosition4.copy(window1.position) 
    flag3 = true 
  }
  if (window1.position.y > 0) {
    window1.position.set(currentPosition4.x, currentPosition4.y, currentPosition4.z)
  }
  if (window1.position.y < -8 && !flag2) {
    currentPosition3.copy(window1.position) 
    flag2 = true
  }
  if (window1.position.y < -8) {
    window1.position.set(currentPosition3.x, currentPosition3.y, currentPosition3.z)
  }
});


/**
 * Click control
 */

function handleEsc_mobile() {
    controls.minPolarAngle =  0;
    controls.maxPolarAngle = Math.PI;
    controls.maxAzimuthAngle = Infinity;
    controls.minAzimuthAngle = Infinity;
    if (aspectRatio == 1.3333333333333333) {
        camera.position.set(23.22, 15.6, -5.98)
    }
    else {
        camera.position.set(22.058, 13.865, -3.781)
    }
    cap.position.x = 0
    cap.position.y = 0
    cap.position.z = 0
    watch.position.x = 0
    watch.position.y = 0
    watch.position.z = 0
    pendant.position.x = 0
    pendant.position.y = 0
    pendant.position.z = 0
    head.position.x = 0
    head.position.y = 0
    head.position.z = 0
    overlay.material.opacity = 0;
    type.style.display = 'none';
}

function handleEsc() {
    if (currentPosition1.x !== 0) {
        controls.minPolarAngle =  0;
        controls.maxPolarAngle = Math.PI;
        controls.maxAzimuthAngle = Infinity;
        controls.minAzimuthAngle = Infinity;
        camera.position.set(currentPosition1.x, currentPosition1.y, currentPosition1.z);
        button1.style.opacity = '0%'
        button2.style.opacity = '0%'
        cap.position.x = 0
        cap.position.y = 0
        cap.position.z = 0
        watch.position.x = 0
        watch.position.y = 0
        watch.position.z = 0
        pendant.position.x = 0
        pendant.position.y = 0
        pendant.position.z = 0
        head.position.x = 0
        head.position.y = 0
        head.position.z = 0
        overlay.material.opacity = 0;
    }
}

function handleCaps_mobile() {
    cancel.style.display = 'block'
    cancel3.style.display = 'none'
    Enter.style.display = 'none'
    end_overlay.style.display = 'none'
}

function handleCaps() {
    Enter.style.display = 'none'
    end_overlay.style.display = 'none'
}

function handleDel_mobile() {
    cap.position.x = 0
    cap.position.y = 0
    cap.position.z = 0
    watch.position.x = 0
    watch.position.y = 0
    watch.position.z = 0
    pendant.position.x = 0
    pendant.position.y = 0
    pendant.position.z = 0
    head.position.x = 0
    head.position.y = 0
    head.position.z = 0
    overlay.material.opacity = 0;
    cancel.style.display = 'block'
    cancel2.style.display = 'none'
}

function handleDel() {
    cap.position.x = 0
    cap.position.y = 0
    cap.position.z = 0
    watch.position.x = 0
    watch.position.y = 0
    watch.position.z = 0
    pendant.position.x = 0
    pendant.position.y = 0
    pendant.position.z = 0
    head.position.x = 0
    head.position.y = 0
    head.position.z = 0
    overlay.material.opacity = 0;
    button1.style.opacity = '15%'
    button2.style.opacity = '0%'
}

function handleShift_mobile() {
    Enter.style.display = 'block'
    button3.style.opacity = '30%'
    end_overlay.style.display = 'block'
    cancel.style.display = 'none'
}

function handleShift() {
    Enter.style.display = 'block'
    button3.style.opacity = '30%'
    end_overlay.style.display = 'block'
}

let input = document.querySelector('.text-field__input');
let finish = document.querySelector('.end');


function handleEnter() {
    if (input.value == 'Вдова' || input.value == 'вдова') {
        end_overlay.style.display = 'block'
        end_overlay.style.opacity = '100%'
        button3.style.opacity = '0%'
        Enter.style.display = 'none'
        cancel3.style.display = 'none'
        finish.style.display = 'flex'
        window.location.reload();
    }
    else {
        let wrong = document.querySelector('.text-field__input');
        wrong.style.border = '0.260vw solid #d31717';
        setTimeout(() => {
            wrong.style.border = '0.260vw solid #bdbdbd';  
        }, 2000);
    }
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight   

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Mouse
 */
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) =>
{
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 + 1
})
let flag_pos = false
let flag_pos_two = false
let flag_pos_three = false
window.addEventListener('click', () =>
{
    if(currentIntersect)
    {
        if (aspectRatio == 1.3333333333333333) {
            camera.position.set(14.69, 8.17, -6.43)
        }
        else {
            camera.position.set(11.69, 8.17, -6.43)
        }
        controls.enableRotate = true;
        controls.minPolarAngle =  Math.PI / 4;
        controls.maxPolarAngle = Math.PI / 2.5;
        controls.maxAzimuthAngle = Math.PI / 1.25;
        controls.minAzimuthAngle = Math.PI / 3;
        button1.style.opacity = '15%'
        cancel.style.display = 'block'
        setTimeout(() => {
            text4.visible = true  
        }, 10000);
    }
    if(currentIntersect2)
    {
        let euler = new THREE.Euler(0, Math.PI / 2, 0, 'XYZ')
        camera.position.set(-12.15, 4, -5.95)
        camera.setRotationFromEuler(euler);
        flag_pos = true
        button1.style.opacity = '15%'
        cancel.style.display = 'block'
        type.style.display = 'block'
    }
    if(currentIntersect3)
    {
        let euler = new THREE.Euler(0, Math.PI / 2, 0, 'XYZ')
        camera.position.set(2.31, 7.78, 3.61)
        camera.setRotationFromEuler(euler);
        flag_pos_two = true
        controls.enableRotate = true;
        controls.minPolarAngle =  Math.PI / 4;
        controls.maxPolarAngle = Math.PI / 5;
        controls.maxAzimuthAngle = Math.PI / 4.1;
        controls.minAzimuthAngle = Math.PI / 8;
        button1.style.opacity = '15%'
        cancel.style.display = 'block'
        setTimeout(() => {
            text2.visible = true  
        }, 7000);
    }
    if(currentIntersect4)
    {
        let euler = new THREE.Euler(0, Math.PI / 2, 0, 'XYZ')
        camera.position.set(-10.31, 7.78, 3.61)
        camera.setRotationFromEuler(euler);
        flag_pos_two = true
        controls.enableRotate = true;
        controls.minPolarAngle =  Math.PI / 4;
        controls.maxPolarAngle = Math.PI / 2.6;
        controls.maxAzimuthAngle = 200 * Math.PI / 180 + 2;
        controls.minAzimuthAngle = 160 * Math.PI / 180 + 2;
        button1.style.opacity = '15%'
        cancel.style.display = 'block'
        setTimeout(() => {
            text3.visible = true  
        }, 4000);
    }
    if(currentIntersect5)
    {
        let euler = new THREE.Euler(0, Math.PI / 2, 0, 'XYZ')
        if (aspectRatio == 1.3333333333333333) {
            controls.minPolarAngle =  Math.PI / 2.4;
            controls.maxPolarAngle = Math.PI / 2.4;
            controls.maxAzimuthAngle = 200 * Math.PI / 180 + 1.55;
            controls.minAzimuthAngle = 160 * Math.PI / 180 + 2;
        }
        else {
            controls.minPolarAngle =  Math.PI / 2.4;
            controls.maxPolarAngle = Math.PI / 2.4;
            controls.maxAzimuthAngle = 200 * Math.PI / 180 + 1.5;
            controls.minAzimuthAngle = 160 * Math.PI / 180 + 2;
        }
        camera.position.set(-26.31, 6.7, 4.2)
        camera.setRotationFromEuler(euler);
        flag_pos_three = true
        controls.enableRotate = true;
        button1.style.opacity = '15%'
        cancel.style.display = 'block'
        setTimeout(() => {
            text5.visible = true  
        }, 5000);
        setTimeout(() => {
            text6.visible = true  
        }, 20000);
    }
    if(currentIntersect6)
    {
        if (cap) {
            cap.position.x = 8
            cap.position.y = 0.9
            cap.position.z = -0.5
            overlay.material.opacity = 0.8;
            button1.style.opacity = '0%'
            button2.style.opacity = '30%'
            cancel.style.display = 'none'
            cancel2.style.display = 'block'
        }
    }
    if(currentIntersect7)
    {
        if (watch) {
            watch.position.x = 9
            watch.position.y = 0.9
            watch.position.z = -0.1
            overlay.material.opacity = 0.8;
            button1.style.opacity = '0%'
            button2.style.opacity = '30%'
            cancel.style.display = 'none'
            cancel2.style.display = 'block'
        }
    }
    if(currentIntersect8)
    {
        if (pendant) {
            pendant.position.x = 9
            pendant.position.y = 2.4
            pendant.position.z = 0.3
            overlay.material.opacity = 0.8;
            button1.style.opacity = '0%'
            button2.style.opacity = '30%'
            cancel.style.display = 'none'
            cancel2.style.display = 'block'
        }
    }
    if(currentIntersect9)
    {
        if (head) {
            head.position.x = 9
            head.position.y = 1.2
            head.position.z = 1.6
            overlay.material.opacity = 0.8;
            button1.style.opacity = '0%'
            button2.style.opacity = '30%'
            cancel.style.display = 'none'
            cancel2.style.display = 'block'
        }
    }

    if(currentIntersect10)
    {
        if (aspectRatio == 1.3333333333333333) {
            camera.position.set(23.22, 15.6, -5.98)
        }
        else {
            camera.position.set(22.058, 13.865, -3.781)
        }
    }
})

/**
 * Animate
 */

const tick = () =>
{
    if (currentPosition1.x !== 0) {
        controls.enableZoom = false;
    }

    if (aspectRatio < 1.675) {
        if (text1) {
            text1.position.set(0, 0.3, -1.93)
        }
    }
    document.addEventListener('keydown', (event) => {
        if (event.key === "Shift") {
            handleShift();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === "CapsLock") {
            handleCaps();
            button3.style.opacity = '0%'
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === "Enter") {
            input = document.querySelector('.text-field__input');
            handleEnter();
        }
    });

    if(car) {
        updatepos();
    }

    cancel.addEventListener('click', () => {
        cancel.style.display = 'none'
        flag_pos = false
        flag_pos_two = false
        flag_pos_three = false
        text2.visible = false 
        text3.visible = false 
        text4.visible = false 
        text5.visible = false 
        text6.visible = false 
        handleEsc_mobile()
    }); 

    type.addEventListener('click', () => {
        handleShift_mobile()
        cancel3.style.display = 'block'
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === "Escape") {
          handleEsc();
          flag_pos = false
          flag_pos_two = false
          flag_pos_three = false
          text2.visible = false 
          text3.visible = false 
          text4.visible = false 
          text5.visible = false 
          text6.visible = false 
        }
    });

    cancel2.addEventListener('click', () => {
        cancel.style.display = 'none'
        handleDel_mobile();
    });

    cancel3.addEventListener('click', () => {
        handleCaps_mobile()
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === "Control") {
          handleDel();
        }
    });

    raycaster.setFromCamera(mouse, camera)

    renderer.domElement.style.cursor = 'default';

    const elapsedTime = clock.getElapsedTime()
    if(table) {
        let distance = camera.position.distanceTo(table.children[0].position);
        if (distance > 18) {
            const modelIntersects = raycaster.intersectObject(table)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect = modelIntersects[0]
            }
            else
            {
                currentIntersect = null
            }  
        }
        else {
            currentIntersect = null 
        }
    }

    if(bar) {
        let distance = camera.position.distanceTo(bar.children[0].position);
        if (distance > 35) {
            const modelIntersects = raycaster.intersectObject(bar)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect2 = modelIntersects[0]
            }
            else
            {
                currentIntersect2 = null
            }  
        }
        else {
            currentIntersect2 = null 
        }
    }
    if(slot) {
        let distance = camera.position.distanceTo(slot.children[0].position);
        if (distance > 0) {
            const modelIntersects = raycaster.intersectObject(slot)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect3 = modelIntersects[0]
            }
            else
            {
                currentIntersect3 = null
            }  
        }
        else {
            currentIntersect3 = null 
        }
    }

    if(tape) {
        let distance = camera.position.distanceTo(tape.children[0].position);
        if (distance > 30) {
            const modelIntersects = raycaster.intersectObject(tape)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect4 = modelIntersects[0]
            }
            else
            {
                currentIntersect4 = null
            }  
        }
        else {
            currentIntersect4 = null 
        }
    }

    if(door) {
        let distance = camera.position.distanceTo(door.position);
        if (distance > 25) {
            const modelIntersects = raycaster.intersectObject(door)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect5 = modelIntersects[0]
            }
            else
            {
                currentIntersect5 = null
            }  
        }
        else {
            currentIntersect5 = null 
        }
    }

    if(cloth1) {
        let distance = camera.position.distanceTo(cloth1.position);
        if (distance > 0) {
            const modelIntersects = raycaster.intersectObject(cloth1)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect6 = modelIntersects[0]
            }
            else
            {
                currentIntersect6 = null
            }  
        }
        else {
            currentIntersect6 = null 
        }
    }

    if(cloth2) {
        let distance = camera.position.distanceTo(cloth2.position);
        if (distance > 0) {
            const modelIntersects = raycaster.intersectObject(cloth2)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect7 = modelIntersects[0]
            }
            else
            {
                currentIntersect7 = null
            }  
        }
        else {
            currentIntersect7 = null 
        }
    }

    if(cloth3) {
        let distance = camera.position.distanceTo(cloth3.position);
        if (distance > 0) {
            const modelIntersects = raycaster.intersectObject(cloth3)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect8 = modelIntersects[0]
            }
            else
            {
                currentIntersect8 = null
            }  
        }
        else {
            currentIntersect8 = null 
        }
    }

    if(cloth4) {
        let distance = camera.position.distanceTo(cloth4.position);
        if (distance > 0) {
            const modelIntersects = raycaster.intersectObject(cloth4)
            
            if(modelIntersects.length)
            {
                renderer.domElement.style.cursor = 'pointer';
                currentIntersect9 = modelIntersects[0]
            }
            else
            {
                currentIntersect9 = null
            }  
        }
        else {
            currentIntersect9 = null 
        }
    }

    if (screenWidth <= 1024) {
        if(car) {
            let distance = camera.position.distanceTo(car.position);
            if (distance > 0) {
                const modelIntersects = raycaster.intersectObject(car)
                
                if(modelIntersects.length)
                {
                    currentIntersect10 = modelIntersects[0]
                    controls.enableZoom = false;
                }
                else
                {
                    currentIntersect10 = null
                }  
            }
            else {
                currentIntersect10 = null 
            }
        }
    }

    portalLightMaterial.uniforms.uTime.value = elapsedTime
    portalLightMaterial1.uniforms.uTime.value = elapsedTime
    portalLightMaterial3.uniforms.uTime.value = elapsedTime
    // Update controls 
    
    controls.update()
    if(flag_pos === true)
    {
        const cameraDirection = new THREE.Vector3(-11.77, 3.09, -6.1);
        let euler = new THREE.Euler(0, Math.PI / 2, Math.PI / 2, 'ZYX')
        camera.setRotationFromEuler(euler);
    }
    if(flag_pos_two === true)
    {
        const cameraDirection = new THREE.Vector3(-11.77, 3.09, -6.1);
        let euler = new THREE.Euler(-Math.PI / 8, -3 * Math.PI / 4 * 1.23, 0, 'ZYX')
        camera.setRotationFromEuler(euler);
    }
    if(flag_pos_three === true)
    {
        const cameraDirection = new THREE.Vector3(-11.77, 3.09, -6.1);
        let euler = new THREE.Euler(-Math.PI / 8, Math.PI / 3, 0, 'ZYX')
        camera.setRotationFromEuler(euler);
    }
    // Render
    renderer.render(scene, camera)

    window.requestAnimationFrame(tick)
}

tick()